import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { LinearProgress } from '@mui/material';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import Button from '../../../Shared/VaultButton';
import {
  DialogHeader,
  DialogHeaderTitle,
  DialogActionsOverride,
  ActionContainer,
} from '../../../Shared/styles/dialog';
import GameScheduleForm from '../../GameScheduleForm/component';
import { IAppState } from '../../../../state/reducers';
import { StickyProgressContainer } from '../../GameScheduleForm/styles';
import {
  createGame, checkUpdateGameId,
  clearAll, selectCanCreateGame,
} from '../../../../state/exchange/createGameScheduleDialog';

class CreateGameSchedule extends PureComponent<IProps> {
  componentDidMount = async () => {
    const {
      checkUpdateGameId,
    } = this.props;
    // note: if season/sport/league cached, get gameId on mount
    checkUpdateGameId();
  };

  componentDidUpdate = async (prevProps: IProps) => {
    const {
      checkUpdateGameId,
    } = this.props;
    // note: get new gameId when season updated
    checkUpdateGameId(prevProps);
  };

  render = () => {
    const {
      onExit,
      canCreateGame,
      createGame,
      isCreating,
    } = this.props;

    return (
      <>
        <DialogHeader
          data-auto="CreateGameDialog"
        >
          <DialogHeaderTitle>
            Create Game
          </DialogHeaderTitle>
        </DialogHeader>
        {isCreating && (
          <StickyProgressContainer>
            <LinearProgress />
          </StickyProgressContainer>
        )}
        <GameScheduleForm />
        <DialogActionsOverride disableSpacing>
          <ActionContainer>
            <Button
              variant="plainOnPaper"
              onClick={onExit}
              disabled={isCreating}
              data-auto="CancelBtn"
            >
              Cancel
            </Button>
            <Button
              variant="primaryOnWhite"
              onClick={createGame}
              disabled={!canCreateGame || isCreating}
              data-auto="SaveNewBtn"
            >
              Create
            </Button>
          </ActionContainer>
        </DialogActionsOverride>
      </>
    );
  };
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  selectedSeason: state.exchange.gameScheduleForm.selectedSeason,
  selectedSport: state.exchange.gameScheduleForm.selectedSport,
  selectedLeague: state.exchange.gameScheduleForm.selectedLeague,
  canCreateGame: selectCanCreateGame(state),
  isCreating: state.exchange.createGameScheduleDialog.isCreating,
});

const mapDispatchToProps: IDispatchProps = {
  onExit: clearAll,
  createGame,
  checkUpdateGameId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateGameSchedule);
